import styled from "styled-components";

export const StyledForm = styled.form`
& .daterange-input {
    & .filter-container {
        input {
            min-height: 40px !important;
        }
    }
}

.hover {
    &:hover {
        cursor: pointer;
    }
}

& .form-wrapper {
    display: flex;
    flex-wrap: wrap;
    ${(props) => (!!props.direction ? "flex-direction: " + props.direction : "flex-direction: row")};
    ${(props) => (!!props.justifyContent ? "justify-content: " + props.justifyContent : "justify-content: start")};
}

& .inputs-container {
    min-width: 330px;
}

& .form-container {
    min-width: 300px;
    margin: 1rem;
}

& .form-container-min {
    min-width: 130px;
    margin: 1rem;
}

& a {
    text-decoration: none;
}

& .modal-title {
    font-size: 16px;
    color:  #6c757d;
    font-weight: 1000;
    margin: 5px !important;
}

& .modal-info {
    font-size: 12px;
    color: #6c757d;
    font-weight: 1000;
    margin: 5px !important;
}

& .modal-info-data {
    font-size: 12px;
    color: #2c3b82;
    margin: 5px !important;
}

& .modal-legend-time {
    font-size: 16px;
    color:  #6c757d;
    font-weight: 1000;
    margin-bottom: 0px !important;
    text-align: center;
}

& .modal-time {
    font-size: 25px;
    color:  #2c3b82;
    font-weight: 1000;
    margin-bottom: 0px !important;
    text-align: center;
}

& .modal-legend-date {
    font-size: 14px;
    color:  #6c757d;
    font-weight: 1000;
    margin-bottom: 0px !important;
    text-align: center;
}

& .modal-align-center {
    margin: 5px !important;
    text-align: center;
}

& .modal-width {
    width: 100%;
}

& .modal-close {
    text-align: right;
    font-weight: 1000;
    color: #EE4B21;

    &:hover {
        cursor: pointer
    }
}

& .default-button-blue {
    max-width: 280px;
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #2c3b82;
    border-radius: 0.25rem;
    background-color: #2c3b82;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #1d254c;
        border: solid 1px #1d254c;
    }
    &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
}

& .default-button-red {
    max-width: 280px;
    min-width: 120px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.8rem;
    &:hover {
        background-color: #c83e1b;
        border: solid 1px #c83e1b;
    }
    &:disabled {
    background-color: #ccc;
    border-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
}

.default-button-red-small {
    padding: 0.20rem .25rem;
    cursor: pointer;
    font-weight: 600;
    border: solid 1px #EE4B21;
    border-radius: 0.25rem;
    background-color: #EE4B21;
    color: #FFF;
    font-size: 0.77rem;
}

.button-resumo {
    background-color: transparent;
    border-color: #b5aeae;
    color: #b5aeae;

    &:hover {
        background-color: #b5aeae;
        border-color: #b5aeae;
        color: #fff;
    }
}

    .button-chat {
        background-color: transparent;
        border-color: #b5aeae;
        color: #b5aeae;

        &:hover {
            background-color: #b5aeae;
            border-color: #b5aeae;
            color: #fff;
        }
    }

& .div-scroll-x {
    overflow-x: hidden;
    overflow-y: scroll;
}

& .input-form {
    padding: 0.6rem 0.5rem;
    border-radius: 0.25rem;
    border: solid 1px #D2D2D2;
    width: -webkit-fill-available;
}
& .input-form-list {
    border-radius: 0.25rem;
    border: solid 1px #D2D2D2;
    width: 6rem;
    min-height: 38px;
}
& .input-form-list-date {
    border-radius: 0.25rem;
    border: solid 1px #D2D2D2;
    width: 25ch;
    min-height: 38px;
}
& .input-table-lote-list {
    border-radius: 0.25rem;
    border: solid 1px #D2D2D2;
    width: 58px;
    min-height: 38px;
}
& .input-hide {
    opacity:0;
}
& .display-none {
    display: none !important;
}
& .addIcon {
    padding: 0.3rem;
    margin: 0.3rem;
    background-color: #D2D2D2;
    border-radius: 0.25rem;
    border: solid 1px #D2D2D2;
    width: -webkit-fill-available;
    font-size: 1rem;
    cursor:hand;
}
& .table td, .table th {
    vertical-align: middle;
    .form-group{
        margin-bottom: 0px;
    }
}
& .tableFooter {
    font-size: small;
    font-weight: bold;
}

& .react-tabs__tab-list { border-bottom: 0px solid #aaa; margin: 0 0 10px; padding: 0; }
& .react-tabs__tab { display: inline-block; border: 0px solid transparent; border-bottom: none; bottom: -1px; position: relative; list-style: none; padding: 6px 12px; cursor: pointer; }
& .react-tabs__tab--selected { border-bottom: 4px solid red; background: #fff; border-color: red; color: black; border-radius: 5px 5px 0 0; }
& .react-tabs__tab-panel { display: none; }
& .react-tabs__tab-panel--selected { display: block; }
& .react-tabs__tab--disabled { border-bottom: 1px solid gray; border-color: red; color: GrayText; cursor: default; }
& .react-tabs__tab:focus:after { content: ""; position: absolute; height: 5px; left: -4px; right: -4px; bottom: -5px; background: red; border-bottom: 1px solid #fff;}

@media only screen and (max-width: 769px) {
    .edit-atividade-timesheet {
        display: inline !important;
    }

    .edit-atividade-timesheet .full-wdith {
        width: 100% !important;
    }

     .full-width {
        width: 100% !important;
    }
}

.mentionSuggestions {
  border: 1px solid #ccc;
  background-color: #fff;
  position: absolute;
  z-index: 100;
}

.opacity-60 {
    opacity: 0.6;
}

.opacity-70 {
    opacity: 0.7;
}

`;
